import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function ArrowLineRight({
    size = ICON_DEFAULT_SIZE,
    color = ICON_DEFAULT_COLOR,
    ...rest
}:IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest}>
            <path d="M7 21L16 12L7 3"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>
    );
}

export default ArrowLineRight;
